import {useLocalSearchParams} from "expo-router";
import UserProfilePage from "@/lib/components/UserProfilePage";
import Page from "@/lib/components/Page";

export default function Index() {
    const {username} = useLocalSearchParams();

    return (
        <Page scrollable={true}>
            <UserProfilePage username={username.toString()} detailed={true}/>
        </Page>
    )
}